module.exports = __webpack_public_path__ + "static/media/portalUsers.c5518e63.svg";